import './index.css';

const Navbar = () => {
    return ( 
        <nav>   
            <div className='head1'>
                <h1>THE <span>JUNGLE</span> BAR</h1>
            </div>
            <div className="head2">
                <div className="links">
                    <a href="">HOME</a>
                    <a href="">SERVICES</a>
                    <a href="">ABOUT US</a>
                    <a href="">CONTACT</a>
                </div>
                
            </div>
        </nav>
     );
}
 
export default Navbar;